/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Form, Table, FormGroup, Input, Label, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Alert from 'react-s-alert';
import moment from 'moment';

// local  imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// import services
import ClientService from '../../../services/ClientService';
import GeneralService from '../../../services/GeneralService';

const SelectedProvider = props => {

    // contexts
    const { theme, fontWeight } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [inviteModal, setInviteModal] = useState({ isVisible: false });
    const [emailRecipients, setEmailRecipients] = useState([{
        name: "",
        email: "",
    }]);
    const [msgPreview, setMsgPreview] = useState("");

    // useEffects
    // generate preview message
    useEffect(() => {
        try {
            let preview = "";
            preview =
                `Dear ${emailRecipients ? Array.prototype.map.call(emailRecipients, function (recipient) { return recipient.name; }).join(", ") : '<Recipient name>'},\n
This is ${user.username} and it's my pleasure to invite you for a psychological counselling session on the Umang Wellness platform.  Please click https://www.umangwellness.com/counsellors to sign up and book a session with my Counsellor - DummyCounsellor.

Yours Sincerely,
${user.username}`;
            setMsgPreview(preview);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client SelectedProvider useEffect', 'Error in try catch block', err.stack);
        }
    }, [emailRecipients]);


    // handle functions
    // handle onChange of Email Recipients
    const handleEmailRecipientsNameChange = id => e => {
        const newEmailRecipients = emailRecipients.map((recipient, rid) => {
            if (id !== rid) return recipient;
            return { ...recipient, name: e.target.value }
        });
        setEmailRecipients(newEmailRecipients);
    }

    const handleEmailRecipientsEmailChange = id => e => {
        const newEmailRecipients = emailRecipients.map((recipient, rid) => {
            if (id !== rid) return recipient;
            return { ...recipient, email: e.target.value }
        });
        setEmailRecipients(newEmailRecipients);
    }

    // handle - add new email recipient
    const handleAddEmailRecipient = () => {
        const newEmailRecipients = emailRecipients.concat({ name: "", email: "" });
        setEmailRecipients(newEmailRecipients);
    }

    // handle - remove an email recipient
    const handleRemoveEmailRecipient = id => () => {
        const newEmailRecipients = emailRecipients.filter((recipient, rid) => id !== rid);
        setEmailRecipients(newEmailRecipients);
    }


    // utility functions
    // sendInvite helper function
    const sendInvite = selectedProvider => e => {
        e.preventDefault();
        setIsLoading(true);

        let dataToSend = {
            emailRecipients: emailRecipients,
            selectedProvider: selectedProvider
        }
        // console.log(dataToSend);
        ClientService.sendMultipleInvite(dataToSend)
            .then(data => {
                setInviteModal({ visible: false });
                setIsLoading(false);
                Alert.info(data.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
            })
            .catch(error => {
                setIsLoading(false);
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
            });


    }


    // logic to display the content
    let element;
    if (props.selectedProvider.isTrue) {
        element =
            <>
                <div className="row" id="providerDetails">
                    <div className="col-sm-3 col-md-3 text-center">
                        <div className="mx-auto text-center" style={{ width: "120px", height: "120px" }}>
                            <img id="counsellorImg" className="m-auto w-100 h-100" src={props.selectedProvider.profileImage} alt="Selected Counsellor" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                        </div>
                        <Button id="recommendMeBtn" className="btn mt-3" style={theme.button} onClick={() => setInviteModal({ isVisible: true })}>Recommend Me</Button>
                    </div>

                    <div className="col-sm-9 col-md-9 my-auto">
                        <Table borderless>
                            <tbody>
                                <tr>
                                    <td style={{ width: '30%' }}>
                                        <span id="counsellor-heading" style={{ fontWeight: fontWeight.medium }}>Counsellor</span>
                                    </td>
                                    <td id="counsellor-name-value">
                                        <span>{props.selectedProvider.name}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td id="speciality-heading">
                                        <span style={{ fontWeight: fontWeight.medium }}>Speciality</span>
                                    </td>
                                    <td id="speciality-value">
                                        <span>{props.selectedProvider.specialities.join(", ")}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span id="available-timing-heading" style={{ fontWeight: fontWeight.medium }}>Available Time</span>
                                    </td>
                                    <td id="available-timing-value">
                                        {
                                            props.selectedProvider.availableTimes.map((item, index) => (
                                                <p key={index} className="mb-0">{`${moment(item.from).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A")} - ${moment(item.to).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A")}`}
                                                    {index + 1 < props.selectedProvider.availableTimes.length ? "," : null}
                                                </p>
                                            ))
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </>
    } else {
        element =
            <>
                <p id="noCounsellorSelected" style={theme.paragraph}>No Counsellor Selected</p>
                <button id="findProviderBtn" className="btn" style={theme.button} onClick={() => props.history.replace('/counsellors')}>Find Counsellor</button>
            </>
    }

    // function's return
    return (
        <div>
            {element}

            <Modal size="lg" isOpen={inviteModal.isVisible} backdrop={true}>
                <ModalHeader id="recommendMeModalHeader" close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setInviteModal({ visible: false })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Recommend Counsellor</span></ModalHeader>
                <ModalBody>
                    <p id="recommendMeModalPara">Select the recipients to whom you would like to recommend your counsellor</p>
                    <Form onSubmit={sendInvite(props.selectedProvider)}>

                        {emailRecipients.map((recipient, rid) => (
                            <div key={rid} className="row">
                                <div className="row col-8 col-sm-10 col-md-10">
                                    <FormGroup className="col-sm-6 col-12 col-md-6">
                                        <Label id="recipentname" style={theme.formBodyText}>Recipient Name #{rid + 1}</Label>
                                        <Input id="recipentnameinput" type="text" value={recipient.name} onChange={handleEmailRecipientsNameChange(rid)} className="form-control" style={theme.formInput} required />
                                    </FormGroup>
                                    <FormGroup className="col-sm-6 col-12 col-md-6">
                                        <Label id="recipentemail" style={theme.formBodyText}>Recipient Email #{rid + 1}</Label>
                                        <Input id="recipentemailinput" type="email" value={recipient.email} onChange={handleEmailRecipientsEmailChange(rid)} className="form-control" style={theme.formInput} required />
                                    </FormGroup>
                                    <hr />
                                </div>

                                <div className="col-3 col-sm-2 col-md-2 my-auto">
                                    <Button id="modalRemoveBtn"
                                        style={theme.formButtonDanger}
                                        onClick={handleRemoveEmailRecipient(rid)}>
                                        Remove
                                    </Button>
                                </div>
                            </div>
                        ))
                        }

                        <Button id="addRecipientBtn"
                            style={theme.formButton}
                            onClick={handleAddEmailRecipient}
                        >
                            Add Recipient
                        </Button>

                        <FormGroup>
                            <Label id="emailParticipents" for="msgPreview" style={theme.formBodyText} >Email Recipients: {Array.prototype.map.call(emailRecipients, function (recipient) { return recipient.email; }).join(", ")}</Label>
                            <Input id="emailParticipentsInput" type="textarea" rows="12" name="msgPreview" className="form-control" style={theme.formInput} value={msgPreview.replace("DummyCounsellor", props.selectedProvider.name)} disabled required />
                        </FormGroup>

                        <Button id="sendbtn" type="submit" style={theme.formButton} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Send</Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default SelectedProvider;